// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","load":"Loader_load__GV44D","icon":"Loader_icon__X58ZX","favicon":"Loader_favicon__jDj9C"};